<form [formGroup]="form" class="flex flex-col">
    <div class="w-full">
        <section class="mb-3">
            <h2 class="!text-primary-800">
                Complete the following fields to auto-populate portions of the
                FCC Form 601.
            </h2>
            <h3 class="!text-primary-800 !italic">
                To skip this optional step, click Next.
            </h3>
        </section>
    </div>

    <div class="grid grid-cols-12">
        <div
            class="flex xl:col-span-3 lg:col-start-2 mb-3 xl:mb-0 lg:col-span-10 col-span-12 w-full justify-between"
        >
            <div class="flex flex-grow">
                <button
                    type="button"
                    color="primary"
                    (click)="openFrnSearchDialog()"
                    mat-stroked-button
                    class="!text-tertiary-50 !rounded-lg !px-6 !py-5 w-full !bg-tertiary-700 text-nowrap"
                >
                    Search for FRN
                </button>
            </div>

            <div class="flex place-content-center w-16">
                <p
                    class="!mt-1.5 px-auto text-primary-900 text-lg font-medium italic"
                >
                    OR
                </p>
            </div>
        </div>

        <div class="w-full responsive-centered-column flex items-start gap-4">
            <mat-form-field
                appearance="outline"
                class="w-full flex-grow flex-shrink-0"
            >
                <mat-label>FCC Registration Number (FRN)</mat-label>
                <input
                    title="FCC Registration Number (FRN)"
                    matInput
                    formControlName="fccRegistrationNumber"
                    [appRegexInput]="regExPattern.NumericOnly"
                    maxLength="10"
                />
                @if (getFrnError(); as error) {
                    <mat-error>{{ error }}</mat-error>
                }
            </mat-form-field>
        </div>
    </div>
    <div class="grid grid-cols-12">
        <div class="w-full responsive-centered-column">
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>Radio Service Code</mat-label>
                <mat-select formControlName="radioServiceCode">
                    @for (
                        radioServiceCode of radioServiceCodes;
                        track radioServiceCode.value
                    ) {
                        <mat-option [value]="radioServiceCode.value">
                            {{ radioServiceCode.label }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <div class="grid grid-cols-12">
        <div class="w-full responsive-centered-column">
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>Applicant/Licensee Legal Entity Type</mat-label>
                <mat-select formControlName="applicantTypeCode">
                    @for (
                        applicantTypeCode of applicantTypeOptions;
                        track applicantTypeCode.value
                    ) {
                        <mat-option [value]="applicantTypeCode.value">
                            {{ applicantTypeCode.label }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
    </div>
</form>
